import './styles.scss'

import React from 'react'
import LoadingPlaceholder from 'lib/components/loading-placeholder'

export default function FakeResult () {
  return (
    <div className={`search-result is-loading`}>
      <div className='result-content'>
        <div className='image'>
          <div className='fake-image large' style={{ width: 150, height: 150 }} />
        </div>
        <div className='responsive-image'>
          <div className='fake-image small' style={{ width: 70, height: 70 }} />
        </div>
        <div className='text'>
          <div className='name-rating-row'>
            <a href='' className='name' target='_blank'>
              <LoadingPlaceholder style={{ width: 100 }} />
              <span className='user-location'>
                {' '}
                - <LoadingPlaceholder style={{ width: 100 }} />
              </span>
            </a>
            <span className='name-rating-price'>
              <LoadingPlaceholder style={{ width: 30 }} />
            </span>
          </div>
          <div className='title-price-row'>
            <div className='title-price-inner'>
              <span className='price'>
                <LoadingPlaceholder style={{ width: 30 }} />
              </span>
              <a className='title-link' href='' target='_blank'>
                <span className='title'>
                  <LoadingPlaceholder style={{ width: '60%' }} />
                </span>
              </a>
            </div>
          </div>
          <div className='result-content'>
            <a href='' target='_blank'>
              <div>
                <LoadingPlaceholder style={{ width: '80%', height: 12 }} />
              </div>
              <div>
                <LoadingPlaceholder style={{ width: '80%', height: 12 }} />
              </div>
              <div>
                <LoadingPlaceholder style={{ width: '80%', height: 12 }} />
              </div>
            </a>
          </div>
          <div className='result-tags'>
            <span key={1}>
              <LoadingPlaceholder style={{ width: 50, height: 10 }} />
            </span>
            <span key={2}> · </span>
            <span key={3}>
              <LoadingPlaceholder style={{ width: 50, height: 10 }} />
            </span>
          </div>
        </div>
        <div className='props'>
          <div className='heart inactive' />
        </div>
      </div>
    </div>
  )
}
